import CheckoutContextDefinition from "./CheckoutContextDefinition";

const initialCheck: CheckoutContextDefinition = {
	dadosPessoais: undefined,
	dadosCompra: undefined,
	scheduleInfo: undefined,
};

export default initialCheck;
